export default "__VITE_ASSET__BJdw22wF__"